import { atom } from 'recoil';

const listTablesAtom = atom({
    key: 'ListTablesAtom',
    default: []
});

export { listTablesAtom };